var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex align-center justify-center fill-height"},[_c('v-card',{attrs:{"loading":_vm.appConfig.loading,"max-width":"600px"}},[_c('v-card-text',[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }